import * as superagent from 'superagent'
import { timeout } from '../../../shared/lib/timeout.no-deps'
import { getAuthUrl } from '../Config'
import { DS_getData, DS_setData } from '../DS/DS.Data'
import { Plat_isCordova } from '../Plat/Plat.device'
import { Auth_getState } from './Auth.State'
import { safariViewControllerAvailable, showSafariViewController } from './Auth.SafariViewController'
import { getRecentUsers } from '../Devi/Devi.recentUsers'
import querystring from 'querystring'

export async function Auth_navigateLogout(accessToken: string) {
    const url = new URL(`${getAuthUrl()}/auth/logout?relayState=login&token=${accessToken}`)
    await waitForPing()
    await navigate(url)
    showBackdrop()
}

export async function Auth_navigateLogin() {
    const authState = Auth_getState()
    if (authState.status === 'pending-automatic-login') {
        return Auth_redirectLogin(authState.email, authState.password)
    }
    const recentUserCount = await getRecentUsers().count()
    if (recentUserCount > 0) {
        // show recent user list
        DS_setData('ContinueToLogin', () => ({ auth: { status: 'ready' } }))
        return
    }
    return Auth_redirectLogin()
}

export async function Auth_redirectSign(
    dataToSign: string,
    redirectPath: string,
    email: string,
    relayState: string,
    cancelRelayState: string
) {
    const url = new URL(
        `${getAuthUrl()}/signature/sign?${querystring.stringify({
            dataToSign,
            relayState,
            cancelRelayState,
            redirectPath: `/#${redirectPath}`,
            email,
        })}`
    )
    await waitForPing()
    await navigate(url)
}

export async function Auth_redirectLogin(email?: string, password?: string, cancelRelayState?: string) {
    const url = new URL(`${getAuthUrl()}/auth/login?relayState=login&ignoreCookies=true`)
    if (email) {
        url.searchParams.append('email', email)
        if (password) {
            url.searchParams.append('password', password)
        }
    }
    if (cancelRelayState != null) {
        url.searchParams.append('cancelRelayState', cancelRelayState)
    }
    await waitForPing()
    await navigate(url)
    showBackdrop()
}

export async function Auth_navigatePasswordChange() {
    const { accessToken } = DS_getData()
    const url = new URL(`${getAuthUrl()}/password/confirm?relayState=password-change&sessionToken=${accessToken}`)
    await navigate(url)
}

async function waitForPing() {
    while (true) {
        try {
            // Test the connection
            await new Promise<void>((resolve, reject) =>
                superagent.get(getAuthUrl() + '/ping').end((err) => (err != null ? reject(err) : resolve()))
            )

            // If connected, keep going
            break
        } catch (_) {
            // Tell the user that there's a problem
            DS_setData('AuthNavigateCannotConnect', () => ({
                auth: { status: 'waiting-for-internet' },
            }))

            // Wait awhile before trying again
            await timeout(500)
        }
    }
}

async function navigate(url: URL) {
    // Sort out the full url
    url.searchParams.append('redirectURI', getRedirectURI())
    const available = await safariViewControllerAvailable()

    // Navigate to the auth page
    if (available) {
        await showSafariViewController(url.toString())
    } else {
        window.location.href = url.toString()
    }
}

function getRedirectURI() {
    // Cordova
    if (Plat_isCordova()) {
        return `${ENV.customUrlScheme}://callback`
    }

    // Browser

    let url = `${location.protocol}//${location.hostname}`

    if (location.port !== '') {
        url += `:${location.port}`
    }

    return url
}

function showBackdrop() {
    // Show a backdrop whilst waiting for the login redirect
    // (The broswer has a back button that can't be removed)
    DS_setData('AuthNavigated', () => ({
        auth: { status: 'waiting-for-redirect' },
    }))
}
